<div class="rs-panel-flex-cell rs-bg-c2">
  <h6 class="rs-txt-c1">
    {{ 'password.recovery.method.sms.title' | translate }}
  </h6>
  <p *ngIf="!showAddNumber">
    <button class="rs-link-action rs-link-action-add" (click)="toggleShowAddNumber()">
      <span class="rs-link-action-label" aria-hidden="true">{{
        'password.recovery.method.sms.add.title' | translate
      }}</span
      ><span
        class="rs-action-link-icon"
        title="{{ 'password.recovery.method.sms.add.title' | translate }}"
        ><span class="show-for-sr">{{
          'password.recovery.method.sms.add.title' | translate
        }}</span></span
      >
    </button>
  </p>

  <span *ngIf="showAddNumber">
    <p class="rs-padding-bottom1">
      {{ 'password.recovery.method.sms.add.description' | translate }}
    </p>
    <mprd-mobile-number-submit
      (mobileNumberSubmitFormStatusAndValue)="onMobileNumberSubmitFormStatusAndValue($event)"
      (mobileNumberSubmitCancel)="onMobileNumberSubmitCancel()"
      [showLoadingSpinner]="showLoadingSpinner"
    >
    </mprd-mobile-number-submit>
    <p class="right rs-margin-right2">
      <span *ngIf="showLoadingSpinner">
        <px-loading-spinner></px-loading-spinner>
      </span>
    </p>
  </span>
</div>
